var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFish = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38.685,
    height: 47.439,
    viewBox: "0 0 38.685 47.439",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-195.8 -977.402)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.979,
    height: 11.068,
    rx: 2.632,
    transform: "translate(225.805 979.995)",
    fill: "none",
    stroke: "#3d5567",
    strokeMiterlimit: 10,
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.586,979.8a1.7,1.7,0,0,1,3.4,0",
    transform: "translate(9.509 0)",
    fill: "none",
    stroke: "#3d5567",
    strokeMiterlimit: 10,
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.987,986.677a1.7,1.7,0,0,1-3.4,0",
    transform: "translate(9.509 4.423)",
    fill: "none",
    stroke: "#3d5567",
    strokeMiterlimit: 10,
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    x2: 7.851,
    transform: "translate(225.87 985.336)",
    fill: "none",
    stroke: "#3d5567",
    strokeMiterlimit: 10,
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.245,991.521v-.579a6.243,6.243,0,0,1,6.242-6.242h0a6.243,6.243,0,0,1,6.242,6.242v8.687a4.763,4.763,0,0,0,4.763,4.763h0a4.762,4.762,0,0,0,4.761-4.763v-9.137",
    transform: "translate(2.628 3.403)",
    fill: "none",
    stroke: "#3d5567",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.326,1013.58l4.955,4.441a24.252,24.252,0,0,0,0-6.436c-.514-2.7-5.019-2.187-5.019-2.187a6.019,6.019,0,0,0,2.627-2.054,12.269,12.269,0,0,0,2.754-10.859,12.115,12.115,0,0,0-3.236-5.575,3.285,3.285,0,0,0-2.307-.946h0a3.284,3.284,0,0,0-2.306.946,12.115,12.115,0,0,0-3.236,5.575,12.265,12.265,0,0,0,2.754,10.859,6,6,0,0,0,2.627,2.054s-4.505-.515-5.02,2.187a24.322,24.322,0,0,0,0,6.436l5.084-4.569Z",
    transform: "translate(0.548 6.119)",
    fill: "none",
    stroke: "#3d5567",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    x2: 15.058,
    transform: "translate(200.151 1004.32)",
    fill: "none",
    stroke: "#3d5567",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    x2: 10.682,
    transform: "translate(202.339 1007.666)",
    fill: "none",
    stroke: "#3d5567",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.03,
    cy: 0.965,
    rx: 1.03,
    ry: 0.965,
    transform: "translate(206.5 999.601)",
    fill: "none",
    stroke: "#3d5567",
    strokeMiterlimit: 10,
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.03,
    cy: 0.965,
    rx: 1.03,
    ry: 0.965,
    transform: "translate(223.5 1015.601)",
    fill: "none",
    stroke: "#3d5567",
    strokeMiterlimit: 10,
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.03,
    cy: 2.965,
    rx: 3.03,
    ry: 2.965,
    transform: "translate(196.5 983.601)",
    fill: "none",
    stroke: "#3d5567",
    strokeMiterlimit: 10,
    strokeWidth: 1.4
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFish, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/fish.46e6d025.svg";
export { ForwardRef as ReactComponent };